import { Link } from "react-router-dom";

import { Panel } from "@/components/panel";

export function NotFoundPage() {
  return (
    <Panel
      title="Page not found"
      description="The address you opened does not match any page in this dashboard."
    >
      <p className="text-sm text-muted">
        Check the link for typos — the page may have been renamed or removed.{" "}
        <Link to="/" className="text-brand-300 underline">
          Go to the Dashboard
        </Link>
      </p>
    </Panel>
  );
}

export default NotFoundPage;
